/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// core components
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, FormText, CardBody } from "reactstrap";
import { withRouter } from "react-router-dom";

import { NavItem } from 'reactstrap';

import logo from "logo_espolads.png";

import routes from "routes.js";
import url from "variables/url.js";

const localBack = url.localBack;
const localFront = url.localFront;
const anuncios = localBack + 'api/Catalog/Anuncios/';
const seguimiento = localBack + 'api/Catalog/seguimientos';
const log = 'https://auth.espol.edu.ec/login?service=' + localFront + 'logCas';

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            token: '',
            expiration: '',
        }

        this.setStorage = this.setStorage.bind(this);
    }

    setStorage(event) {

        event.preventDefault();

        const data = {
            "username": document.getElementById("email").value,
            "password": document.getElementById("password").value
        }

        console.log(data);        

        fetch(localBack + 'api/accounts/login', {

            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),

        }).then(response => response.json()).
            then(data => {
                let respuesta = data;
                if (respuesta.token != null) {
                    sessionStorage.setItem('username', document.getElementById("email").value);
                    sessionStorage.setItem('token', respuesta.token);
                    sessionStorage.setItem('expiration', respuesta.expiration);
                    this.props.history.push('/creator/mis-comunicados');
                    console.log(respuesta.token)
                }
            }).catch(function (err) {
                alert('Usuario o contraseña incorrectos');
            });
    }

    render() {
        return (
            <div className="wrapper">
                <Container>
                    <Row>
                        <Col sm={{ size: 4, offset: 4 }}>
                            <div className="login-content">
                                <img src={logo} alt="react-logo" className="img-fluid" />
                                {/*<Form className="form-login" onSubmit={this.setStorage}>*/}
                                {/*  <FormGroup className="mb-4">*/}
                                {/*    <Input type="text" name="email" id="email" placeholder="EMAIL" required/>*/}
                                {/*  </FormGroup>*/}
                                {/*  <FormGroup>*/}
                                {/*    <Input type="password" name="password" id="password" placeholder="PASSWORD" required/>*/}
                                {/*  </FormGroup>                              */}
                                {/*    <Button type="submit">LOGIN</Button>*/}
                                {/*</Form>*/}
                                <CardBody>
                                    <p>La sesión ha caducado vuelva a iniciar sesión: </p>                                    
                                </CardBody>
                                <a href={log} className="nav-link">                                    
                                    <p>
                                        <span className="">Iniciar Sesi&oacute;n</span>
                                    </p>
                                 </a>
                                 
                            </div>
                        </Col>
                    </Row>                                        
                </Container>
            </div>
        );
    }
}

//export default Login;
export default withRouter(Login);

